<template>
  <div id="services" :class="{desktop: $store.state.isDesktop, 'no-background': !needBackground, logged : User.token}">

    <div class="servicesContainer" v-if="!guest">
      <div :key="category.id" class="category" v-for="category of categories">
        <div class="title">{{ $to(category.name) }}</div>
        <div class="services">
          <div :key="'service' + service.id + '-' + category.id"
               @click="toService(service.id)" class="service"
               v-for="service of category.services.filter(s => s.active)">

            <div class="image">
              <img :src="CONFIG.urlFiles + service.icon" alt="" v-if="service.icon">
            </div>
            <div class="name">{{ $to(service.name) }}</div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import Services, { Service } from '../../core/Services';
  import Schedules from "../../core/Schedules";
  import User from '../../core/User';

  export default {

    name: "services",

    data() {
      return {
        User,
        Services,
        Schedules,
        guest: false,
        CONFIG
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: this.service ? this.$to(this.service.name) : "menu.services",
        headerIcon: "/svg/services.svg"
      });

      if (this.User.token) {
        Services.init();
      } else if (!CONFIG.cogir) {
        Services.init(true);
      } else {
        this.$router.push("/no-account?login=true");
      }
    },

    computed: {
      categories() {
        return this.Services.categories.filter(c => !c.deleted && c.services.filter(s => s.active).length > 0);
      },
      needBackground() {
        return !this.$store.state.isDesktop;
      }
    },

    methods: {
      toService(id) {
        let service = Services.get(id);
        let target = '_blank';
        if (service.link && !service.email && !service.phoneNumber && !Schedules.getForService(service.id)) {
          let website = !(/^((http|https):\/\/)/.test(service.link)) ?  "http://" + service.link : service.link;

          if (typeof cordova != "undefined" && typeof device != "undefined" && device.platform == "Android") {
            cordova.InAppBrowser.open(website, target, 'location=yes,usewkwebview=yes,toolbar=no');
          } else if (typeof cordova != "undefined"){
            cordova.InAppBrowser.open(website, target, 'location=no,usewkwebview=yes,toolbar=yes');
          } else {
            window.open(website, target);
          }
          return;
        }

        this.$router.push("/services/" + id);
      }
    }

  }

</script>

<style lang="scss" scoped>

  #services {
    background-image: url(../assets/img/background-services.png);
    background-size: cover;
    background-position: center;
    
    &.no-background {
      background-image: none;
      background-color: #f2f3f4;
    }
    
    &.desktop {

      .servicesContainer {
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 60px 30px 10px 30px;
      }

      .category {
        width: 50%;
        padding: 0 30px 30px 30px;
      }

      .title {
        color: #001722;
        font-size: 16px;

        &:before, &:after {
          background-color: #bfc5c8;
        }
      }
      .image {
        border-color: transparent;
        background-color: #405159;
        cursor: pointer;
      }
      .name {
        color: #001722;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .servicesContainer {
    padding: 30px 30px 10px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .title {
    font-size: 12px;
    color: #bfc5c8;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &:before, &:after {
      content: "";
      background-color: #bfc5c8;
      height: 1.5px;
      flex-grow: 1;
    }
    &:before {
      margin-right: 5px;
    }
    &:after {
      margin-left: 5px;
    }
  }

  .services {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    position: relative;
  }

  .service {
    color: white;
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 10px 20px;
    min-width: 27%;

    .image {
      width: 70px;
      height: 70px;
      background-color: #617279;
      border: 2px solid white;
      border-radius: 50%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 40px;
        max-height: 40px;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .name {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 601px) {
    #services {
      &:not(.logged) {
        display:flex;
        justify-content: center;
        align-items:baseline;
      }
    }
    .services {
      display: grid;
      grid-template-columns: repeat(auto-fill, 110px);
      grid-column-gap: 10px;
    }
    .service {
      min-width: auto;
      flex-grow: 0;
    }
  }

</style>